<template>
  <section style="background: #FFFFFF;padding: 10px">
    <div class="appeal-info">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为贯彻落实《中华人民共和国中小企业促进法》、《保障中小企业款项支付条例》（国务院令第728号），以及省委省政府《关于进一步促进民营经济和中小企业高质量发展若干政策措施的通知》（青发〔2019〕13号）文件精神，搭建起长效、完善、有序、畅通的政企沟通渠道，协调解决政府机关、事业单位及大型企业拖欠中小企业款项的实际问题，规范投诉受理督办机制，切实维护中小企业合法权益，营造良好的营商环境，助力全省中小企业高质量发展，设立中小企业投诉受理渠道，受理中小企业对本省机关、事业单位及大型企业拒绝或者迟延支付中小企业货物、工程、服务款项提起投诉等事项。
    </div>
    <div class="fill-hint">
      * 提示：请您如实填写，带*号的为必填项，我们将对涉及您的个人信息保密。
    </div>
    <el-form label-position="right" :rules="payInfoRules" ref="payInfoformRef" :model="appealInfo" label-width="170px">
      <span class="payInfoTag">投诉方信息</span>
      <el-row :gutter="20" style="margin-top: 15px">
        <el-col :span="12">
          <el-form-item label="企业名称：" prop="enterpriseName">
            <el-input v-model="appealInfo.enterpriseName" maxlength="250"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码：" prop="enterpriseCode">
            <el-input v-model="appealInfo.enterpriseCode" maxlength="18"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业所在地：" prop="park">
            <el-row style="width: 100%">
              <el-col :span="12">
                <el-cascader clearable
                             ref="cascader"
                             v-model="appealInfo.locateArea"
                             :props="{ expandTrigger: 'hover',checkStrictly: true,emitPath:false }"
                             :options="locateAreaOptions"
                             @change="handleLocateAreaChange"
                             placeholder="请选择地区" style="width:100%">
                </el-cascader>
              </el-col>
              <el-col :span="12">
                <el-select
                  clearable
                  style="width: 100%"
                  v-model="appealInfo.park"
                  filterable
                  placeholder="请选择园区">
                  <el-option
                    v-for="item in parkList"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select></el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业规模：" prop="enterpriseSize">
            <el-select v-model="appealInfo.enterpriseSize" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in enterpriseSizeList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业性质：" prop="enterpriseType">
            <el-select v-model="appealInfo.enterpriseType" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in enterpriseTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业行业：" prop="enterpriseIndustry">
            <el-select v-model="appealInfo.enterpriseIndustry" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in enterpriseIndustryList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="拖欠金额：" prop="amount">
            <el-input maxlength="50" v-model="appealInfo.amount">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="拖欠类型：" prop="appealType">
            <el-select v-model="appealInfo.appealType" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in appealPayTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="合同总金额：" prop="projectAmount">
            <el-input maxlength="150" v-model="appealInfo.projectAmount">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="诉求主要涉及单位：" prop="appealRelatedOrg">
            <el-input maxlength="50" v-model="appealInfo.appealRelatedOrg"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业联系人：" prop="contactPerson">
            <el-input maxlength="50" v-model="appealInfo.contactPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="contact">
            <el-input maxlength="50" v-model="appealInfo.contact"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系邮箱：" prop="email">
            <el-input maxlength="150" v-model="appealInfo.email"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!--被投诉方-->
      <span class="payInfoTag">被投诉方信息</span>
      <el-row :gutter="10" style="margin-top: 15px">
        <el-col :span="12">
          <el-form-item label="单位/企业名称：" prop="antiEnterpriseName">
            <el-input v-model="appealInfo.antiEnterpriseName" maxlength="250"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码：" prop="antiEnterpriseCode">
            <el-input v-model="appealInfo.antiEnterpriseCode" maxlength="18"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="被投诉方所在地：" prop="antiAddress">
            <el-input v-model="appealInfo.antiAddress" maxlength="200"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位/企业性质：" prop="antiEnterpriseType">
            <el-select v-model="appealInfo.antiEnterpriseType" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in antiEnterpriseTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系人：" prop="antiContactPerson">
            <el-input maxlength="50" v-model="appealInfo.antiContactPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="antiContact">
            <el-input maxlength="50" v-model="appealInfo.antiContact"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="诉求事项说明：" prop="appealContent">
            <el-input v-model="appealInfo.appealContent" type="textarea" :rows="6" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="上传附件">
            <el-upload
              class="upload-demo"
              action="/appeal/file/upload/appealAttachment"
              :on-success="handleAttachmentSuccess"
              :on-remove="handleRemove"
              multiple
              :file-list="fileList">
              <el-button icon="el-icon-upload" type="main">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :offset="2" :span="22" style="font-size: 13px;">
          <div>投诉需提交的证明材料:</div>
          <div>1.投诉事项未经人民法院、仲裁机构、其他行政管理部门或行业协会等社会调解机构受理或受理的承诺书原件扫描件。</div>
          <div>2.法定代表人（负责人）身份证明书原件扫描件。</div>
          <div>3.企业营业执照复印件加盖公章扫描件。</div>
          <div>4.法定代表人身份证原件扫描件。（身份证正反面同页）</div>
          <div>5.受委托人身份证原件扫描件及授权委托书原件扫描件。（身份证正反面同页）</div>
          <div>6.相关合同原件扫描件。（每一份合同扫描为一个PDF文件）</div>
        </el-col>
      </el-row>
    </el-form>
    <div style="width: 100%;text-align: center;margin-top: 10px;">
      <el-button type="main" style="width: 150px;" round @click="handleAppealPaySubmit">提 交</el-button>
    </div>
  </section>
</template>
<script>
  import { portalEnterpriseAppealPay, portalDictionary, portalOrganizationList, portalParkList, portalUserInfo,portalAppealInfo,portalAppealInfoEdit,portalAreaTree} from '@/api/restapi.js'
  export default {
    data () {
      var validatePark = (rule, value, callback) => {
        if (!this.appealInfo.locateArea && !this.appealInfo.park) {
          callback(new Error("请至少选择一项"))
        } else {
          //任意值被填写，清除验证提示
          if (!this.appealInfo.locateArea || !this.appealInfo.park) {
            this.$refs.payInfoformRef.clearValidate()
          }
          callback()
        }
      }
      return {
        fileList: [],
        appealInfo: {
          attachments: []
        },
        userInfo: {},
        appealPayTypeList: [],
        enterpriseSizeList: [],
        enterpriseTypeList: [],
        enterpriseIndustryList: [],
        antiEnterpriseTypeList: [],
        organizationList: [],
        locateAreaOptions: [],
        parkList: [],
        payInfoRules: {
          enterpriseName: [
            { required: true, message: '请填写企业名称', trigger: 'blur' }
          ],
          antiEnterpriseName: [
            { required: true, message: '请填写被投诉方名称', trigger: 'blur' }
          ],
          antiEnterpriseCode: [
            // { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18,message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { pattern:/^[A-Za-z0-9]+$/, message: '只能输入数字、字母', trigger: 'blur'}
          ],
          enterpriseCode: [
            { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18,message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { pattern:/^[A-Za-z0-9]+$/, message: '只能输入数字、字母', trigger: 'blur'}
          ],
          legalPerson: [
            { required: true, message: '请填写法定代表人', trigger: 'blur' }
          ],
          contactPerson: [
            { required: true, message: '请填写企业联系人', trigger: 'blur' }
          ],
          contact: [
            { required: true, message: '请填写联系电话', trigger: 'blur' }
          ],
          contactIdCard: [
            { required: true, message: '请填写联系人身份证号', trigger: 'blur' }
          ],
          park: [
            { required: true, validator: validatePark, trigger: 'change' }
          ],
          enterpriseSize: [
            { required: true, message: '请选择企业规模', trigger: 'change' }
          ],
          enterpriseType: [
            { required: true, message: '请选择企业性质', trigger: 'change' }
          ],
          antiEnterpriseType: [
            { required: true, message: '请选择企业性质', trigger: 'change' }
          ],
          enterpriseIndustry: [
            { required: true, message: '请选择企业行业', trigger: 'change' }
          ],
          appealType: [
            { required: true, message: '请填写诉求类型', trigger: 'blur' }
          ],
          organizationIds: [
            { required: true, message: '请选择诉求主要涉及单位', trigger: 'blur' }
          ],
          appealRelatedOrg: [
            { required: true, message: '请填写诉求主要涉及单位', trigger: 'blur' }
          ],
          contractName: [
            { required: true, message: '请填写合同/协议项目名称', trigger: 'blur' }
          ],
          payLastTime: [
            { required: true, message: '请填写约定的付款期限', trigger: 'blur' }
          ],
          amount: [
            { required: true, message: '请填写拖欠金额', trigger: 'blur' }
          ],
          projectAmount: [
            { required: true, message: '请填写合同总金额', trigger: 'blur' }
          ],
          email: [
            { required: true, message: '请填写联系邮箱', trigger: 'blur' }
          ],
          antiAddress: [
            { required: true, message: '请填写被投诉方所在地', trigger: 'blur' }
          ],
          antiContactPerson: [
            { required: true, message: '请填写联系人', trigger: 'blur' }
          ],
          antiContact: [
            { required: true, message: '请填写联系电话', trigger: 'blur' }
          ],
          appealContent: [
            { required: true, message: '请填写诉求事项说明', trigger: 'blur' }
          ],
        },
        appealType: 'payInfo'
      }
    },
    mounted () {
      portalUserInfo().then(res => {
        if (res.data.code !== 0) {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }else {
          this.userInfo = res.data.data
          if (!(this.userInfo.organization&&this.userInfo.organizationCode
            &&this.userInfo.legalPerson&&this.userInfo.legalPersonPhone
            &&this.userInfo.name&&this.userInfo.phone
            &&this.userInfo.email&&this.userInfo.employee
            &&this.userInfo.enterpriseSize&&this.userInfo.enterpriseType
            &&this.userInfo.registerMoney&&this.userInfo.registerTime
            &&this.userInfo.registerAddress&&this.userInfo.registerDetailAddress
            &&this.userInfo.locationArea&&this.userInfo.address
            &&this.userInfo.licenseUrl&&this.userInfo.commitmentUrl)) {
              this.$parent.handleDropDwonCommand('my_company')
              this.$parent.showErrorMsg('请完善企业信息')
          }
        }
      })
      portalAreaTree().then(res => {
        if (res.data.code === 0){
          this.locateAreaOptions = res.data.data
        }
      })
      portalDictionary('appeal_pay_type').then(res => {
        if (res.data.code === 0) {
          this.appealPayTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_size').then(res => {
        if (res.data.code === 0) {
          this.enterpriseSizeList = res.data.data
        }
      })
      portalDictionary('enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.enterpriseTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_industry').then(res => {
        if (res.data.code === 0) {
          this.enterpriseIndustryList = res.data.data
        }
      })
      portalDictionary('anti_enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.antiEnterpriseTypeList = res.data.data
        }
      })
      this.queryParkAsync('')
      portalOrganizationList('').then(res => {
        if (res.data.code === 0) {
          res.data.data.list.forEach(o => {
            this.organizationList.push({
              name: o.name,
              id: o.id
            })
          })
          if (this.$route.query.id) {
            portalAppealInfo(this.$route.query.id).then(res => {
              if (res.data.code === 0){
                this.appealInfo = res.data.data
                if (this.appealInfo.infoType==='pay') {
                  this.appealType = 'payInfo'
                }
                if (this.appealInfo.attachments) {
                  this.appealInfo.attachments.forEach(file => {
                    this.fileList.push({
                      name: file.fileName,
                      response: {
                        data: file.fileUrl
                      }
                    })
                  })
                }
              }
            })
          }else {
            this.initEmptyAppealInfo()
          }
        }
      })
    },
    methods: {
      updateUserInfo (newInfo) {
        console.log('update new info')
        console.log(newInfo)
        this.userInfo = Object.assign({},newInfo)
      },
      handleLocateAreaChange (value) {
        portalParkList('',value).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
            this.appealInfo.park = ''
          }
        })
        this.$refs.cascader.toggleDropDownVisible(false);
      },
      initEmptyAppealInfo () {
        this.appealInfo = Object.assign({attachments:[]},{
          enterpriseName: this.userInfo.organization,
          enterpriseCode: this.userInfo.organizationCode,
          park: this.userInfo.locationArea?parseInt(this.userInfo.locationArea):undefined,
          enterpriseType: this.userInfo.enterpriseType,
          legalPersonPhone: this.userInfo.legalPersonPhone,
          contactPerson: this.userInfo.name,
          enterpriseSize: this.userInfo.enterpriseSize,
          contact: this.userInfo.phone,
          detailAddress: this.userInfo.address,
          email: this.userInfo.email
        })
      },
      handleAttachmentSuccess (res, file) {
        this.appealInfo.attachments.push({
          fileName: file.name,
          fileUrl: file.response.data
        })
      },
      handleRemove (res, file) {
        let att = []
        file.forEach(f => {
          att.push({
            fileName: f.name,
            fileUrl: f.response.data
          })
        })
        this.appealInfo.attachments = att
      },
      valForm (formRef) {
        let isValid = true
        this.$refs[formRef].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          this.$message({
            showClose: true,
            message: '请检查填写内容',
            type: 'error'
          })
        }
        return isValid
      },
      queryOrgAsync (queryString, cb) {
        portalOrganizationList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            cb(names)
          }
        })
      },
      handleOrgSelect (item) {
        this.appealInfo.appealOrganization = item.id
      },
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
          }
        })
      },
      handleParkSelect (item) {
        this.appealInfo.park = item.id
      },
      handleAppealPaySubmit () {
        if (!(this.userInfo.organization&&this.userInfo.organizationCode
          &&this.userInfo.legalPerson&&this.userInfo.legalPersonPhone
          &&this.userInfo.name&&this.userInfo.phone
          &&this.userInfo.email&&this.userInfo.employee
          &&this.userInfo.enterpriseSize&&this.userInfo.enterpriseType
          &&this.userInfo.registerMoney&&this.userInfo.registerTime
          &&this.userInfo.registerAddress&&this.userInfo.registerDetailAddress
          &&this.userInfo.locationArea&&this.userInfo.address
          &&this.userInfo.licenseUrl&&this.userInfo.commitmentUrl)) {
            this.$parent.handleDropDwonCommand('my_company')
            this.$parent.showErrorMsg('请完善企业信息')
            return
        }
        let val = this.valForm('payInfoformRef')
        if (!val) {
          return
        }
        if (this.appealInfo.id) {
          portalAppealInfoEdit(this.appealInfo).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.$router.push('/portal/appealProgress')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        }else {
          portalEnterpriseAppealPay(this.appealInfo).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.$router.push('/portal/appealProgress')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        }
      }
    }
  }
</script>
<style>
  .el-tabs {
    background: #FFFFFF;
    padding: 10px;
  }
  .el-tabs__active-bar {
    background-color: #aa051a;
    height: 4px;
  }
  .el-tabs__item {
    font-size: 15px;
  }
  .el-tabs__item.is-active {
    color: #07438A;
  }
  .appeal-info {
    font-size: 13px;
  }
  .el-cascader-panel .el-radio{
    z-index: 10;
    width: 99%;
    height: 99%;
    position: absolute;
    top: 10px;
    right: -12px;
  }
  .el-cascader-panel .el-radio__input{
    visibility: hidden;
  }
  .el-cascader-panel .el-cascader-node__postfix{
    top: 10px;
  }
  .fill-hint {
    font-size: 10px;
    color: #FF0000;
    margin: 10px 0;
  }
  .payInfoTag {
    color: #0068BC;
    border: 1px solid #0068BC;
    font-size: 15px;
    margin-left: 50px;
    border-radius: 5px;
    background: #f4fbfe;
    padding: 3px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/PortalPaymentAppeal.vue